
import { Pipe, PipeTransform } from '@angular/core';
import { Jurisdiction } from '../../foundation/models/enums/jurisdiction.enum';

@Pipe({ name: 'jurisdictionCode' })
export class JurisdictionCodePipe implements PipeTransform {

    transform(value: number) {
        return this.getLookupValue(value);
    }

    getLookupValue(id: number) {
        // attempts to use select list item
        var jurisdictions = new Jurisdiction().GetAll();
        const foundValue = jurisdictions.find(i => +i.id === id);
        if (foundValue) {
            if (foundValue.code) {
                return foundValue.code;
            }
        }
        return undefined;
    }
}
